import { figmaPxToWidthPercent, REPORT_PAGE_DEFAULT_PADDING } from '@ui/Report';

/** Page title — Figma node 4767:41120 "Sammanfattning". */
export const REPORT_PAGE_TITLE = {
  offsetLeft: REPORT_PAGE_DEFAULT_PADDING,
  offsetTop: figmaPxToWidthPercent(108),
  fontFamily: '"Roboto", sans-serif',
  fontSize: figmaPxToWidthPercent(62),
  fontWeight: 900,
  lineHeight: 1.15,
  color: '#282a31',
} as const;

/** Body copy under page title — Figma node 4767:41121. */
export const REPORT_BODY_TEXT = {
  fontFamily: '"Roboto", sans-serif',
  fontSize: figmaPxToWidthPercent(17),
  fontWeight: 400,
  lineHeight: 1.3,
  color: '#282a31',
  textAlign: 'justify',
} as const;

/** Max width for editable page header title + body (Figma dashboard title block). */
export const REPORT_PAGE_HEADER_MAX_WIDTH = figmaPxToWidthPercent(900);
